export { default } from "./createStyled.mjs";
export * from "./createStyled.mjs";